define("shared/components/shared/address-fields", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service", "@ember/utils", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _service, _utils, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/utils",0,"later/utils/constants",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div data-test-id="address-fields" class="u--m__b u--block" ...attributes>
    <label class="u--m__b__xs" data-test-id="shipping-address">{{t "account.subscription.billing.address.title"}}</label>
    <p class="u--text--sm u--text--light" data-test-id="address-tax-text">{{t "account.subscription.billing.address.description"}}</p>
  
    {{#if (and this.unsavedAddressNotFound @showErrors)}}
      <p data-test-id="address-not-found-error" class="u--text--danger u--m__tb__md">
        {{svg-jar "warning" class="o--icon o--icon--danger u--m__r__xs"}}
        {{t "errors.address.no_matches"}}
      </p>
    {{/if}}
  
    <div class="o--formWrapper u--m__b__xs">
      <Shared::AddressFields::Country
        @country={{@country}}
        @field={{this.addressFieldKeys.COUNTRY}}
        @showErrors={{@showErrors}}
        @suggestions={{this.suggestedChanges}}
        @setSelectedCountry={{@setSelectedCountry}}
        @isDisabled={{@isDisabled}}
      />
    </div>
  
    {{! Address line 1 }}
    <div class="o--formWrapper u--m__b__xs">
      <Shared::AddressFields::Item
        @qaClass="qa--address_street"
        @emptyText={{t "errors.address.empty.line_one"}}
        @invalidText={{t "errors.address.invalid_line"}}
        @placeHolder={{t "account.subscription.billing.address.address_1"}}
        @field={{this.addressFieldKeys.LINE_ONE}}
        @showErrors={{@showErrors}}
        @value={{@line1}}
        @setSuggestion={{@setSuggestion}}
        @isDisabled={{@isDisabled}}
        @isRequired={{includes this.addressFieldKeys.LINE_ONE this.requiredFields}}
      />
    </div>
  
    {{! Address line 2 }}
    <div class="o--formWrapper u--m__b__xs">
      <Shared::AddressFields::Item
        @qaClass="qa--address_unit"
        @invalidText={{t "errors.address.invalid_line"}}
        @placeHolder={{t "account.subscription.billing.address.address_2"}}
        @field={{this.addressFieldKeys.LINE_TWO}}
        @showErrors={{false}}
        @value={{@line2}}
        @isDisabled={{@isDisabled}}
        @isRequired={{includes this.addressFieldKeys.LINE_TWO this.requiredFields}}
      />
    </div>
    <div class="u--row u--row--noCollapse">
      <div class="u--col__4">
        <div class="o--formWrapper u--m__b__0">
          {{! City }}
          <Shared::AddressFields::Item
            @qaClass="qa--address_city"
            @invalidText={{t "errors.address.invalid_city"}}
            @placeHolder={{t "account.subscription.billing.address.city"}}
            @field={{this.addressFieldKeys.CITY}}
            @showErrors={{@showErrors}}
            @value={{@city}}
            @setSuggestion={{@setSuggestion}}
            @isDisabled={{@isDisabled}}
            @isRequired={{includes this.addressFieldKeys.CITY this.requiredFields}}
          />
        </div>
      </div>
      <div class="u--col__4">
        <div class="o--formWrapper u--m__b__0">
          {{! State }}
          <Shared::AddressFields::Item
            @qaClass="qa--address_state"
            @invalidText={{t "errors.address.invalid_state"}}
            @placeHolder={{t "account.subscription.billing.address.state"}}
            @field={{this.addressFieldKeys.STATE}}
            @showErrors={{@showErrors}}
            @value={{@state}}
            @setSuggestion={{@setSuggestion}}
            @isDisabled={{@isDisabled}}
            @isRequired={{includes this.addressFieldKeys.STATE this.requiredFields}}
          />
        </div>
      </div>
      <div class="u--col__4">
        <div class="o--formWrapper u--m__b__0">
          {{! Zip code/Postal Code }}
          <Shared::AddressFields::Item
            @qaClass="qa--address_zip"
            @invalidText={{t "errors.address.invalid_postal_code"}}
            @placeHolder={{t "account.subscription.billing.address.zip_code"}}
            @field={{this.addressFieldKeys.POSTAL_CODE}}
            @showErrors={{@showErrors}}
            @value={{@postalCode}}
            @setSuggestion={{@setSuggestion}}
            @isDisabled={{@isDisabled}}
            @isRequired={{includes this.addressFieldKeys.POSTAL_CODE this.requiredFields}}
          />
        </div>
      </div>
      {{#if this.hasSameLineEmptyErrors}}
        <div class="u--col__12">
          <span class="o--form__helpText is--error u--m__tb__xs">{{this.sameLineErrorText}}</span>
        </div>
      {{/if}}
    </div>
  </div>
  
  */
  {
    "id": "3GxohoJO",
    "block": "[[[11,0],[24,\"data-test-id\",\"address-fields\"],[24,0,\"u--m__b u--block\"],[17,1],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"u--m__b__xs\"],[14,\"data-test-id\",\"shipping-address\"],[12],[1,[28,[35,0],[\"account.subscription.billing.address.title\"],null]],[13],[1,\"\\n  \"],[10,2],[14,0,\"u--text--sm u--text--light\"],[14,\"data-test-id\",\"address-tax-text\"],[12],[1,[28,[35,0],[\"account.subscription.billing.address.description\"],null]],[13],[1,\"\\n\\n\"],[41,[28,[37,2],[[30,0,[\"unsavedAddressNotFound\"]],[30,2]],null],[[[1,\"    \"],[10,2],[14,\"data-test-id\",\"address-not-found-error\"],[14,0,\"u--text--danger u--m__tb__md\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__r__xs\"]]]],[1,\"\\n      \"],[1,[28,[35,0],[\"errors.address.no_matches\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[12],[1,\"\\n    \"],[8,[39,4],null,[[\"@country\",\"@field\",\"@showErrors\",\"@suggestions\",\"@setSelectedCountry\",\"@isDisabled\"],[[30,3],[30,0,[\"addressFieldKeys\",\"COUNTRY\"]],[30,2],[30,0,[\"suggestedChanges\"]],[30,4],[30,5]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[1,\"  \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[12],[1,\"\\n    \"],[8,[39,5],null,[[\"@qaClass\",\"@emptyText\",\"@invalidText\",\"@placeHolder\",\"@field\",\"@showErrors\",\"@value\",\"@setSuggestion\",\"@isDisabled\",\"@isRequired\"],[\"qa--address_street\",[28,[37,0],[\"errors.address.empty.line_one\"],null],[28,[37,0],[\"errors.address.invalid_line\"],null],[28,[37,0],[\"account.subscription.billing.address.address_1\"],null],[30,0,[\"addressFieldKeys\",\"LINE_ONE\"]],[30,2],[30,6],[30,7],[30,5],[28,[37,6],[[30,0,[\"addressFieldKeys\",\"LINE_ONE\"]],[30,0,[\"requiredFields\"]]],null]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[1,\"  \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[12],[1,\"\\n    \"],[8,[39,5],null,[[\"@qaClass\",\"@invalidText\",\"@placeHolder\",\"@field\",\"@showErrors\",\"@value\",\"@isDisabled\",\"@isRequired\"],[\"qa--address_unit\",[28,[37,0],[\"errors.address.invalid_line\"],null],[28,[37,0],[\"account.subscription.billing.address.address_2\"],null],[30,0,[\"addressFieldKeys\",\"LINE_TWO\"]],false,[30,8],[30,5],[28,[37,6],[[30,0,[\"addressFieldKeys\",\"LINE_TWO\"]],[30,0,[\"requiredFields\"]]],null]]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper u--m__b__0\"],[12],[1,\"\\n\"],[1,\"        \"],[8,[39,5],null,[[\"@qaClass\",\"@invalidText\",\"@placeHolder\",\"@field\",\"@showErrors\",\"@value\",\"@setSuggestion\",\"@isDisabled\",\"@isRequired\"],[\"qa--address_city\",[28,[37,0],[\"errors.address.invalid_city\"],null],[28,[37,0],[\"account.subscription.billing.address.city\"],null],[30,0,[\"addressFieldKeys\",\"CITY\"]],[30,2],[30,9],[30,7],[30,5],[28,[37,6],[[30,0,[\"addressFieldKeys\",\"CITY\"]],[30,0,[\"requiredFields\"]]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper u--m__b__0\"],[12],[1,\"\\n\"],[1,\"        \"],[8,[39,5],null,[[\"@qaClass\",\"@invalidText\",\"@placeHolder\",\"@field\",\"@showErrors\",\"@value\",\"@setSuggestion\",\"@isDisabled\",\"@isRequired\"],[\"qa--address_state\",[28,[37,0],[\"errors.address.invalid_state\"],null],[28,[37,0],[\"account.subscription.billing.address.state\"],null],[30,0,[\"addressFieldKeys\",\"STATE\"]],[30,2],[30,10],[30,7],[30,5],[28,[37,6],[[30,0,[\"addressFieldKeys\",\"STATE\"]],[30,0,[\"requiredFields\"]]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper u--m__b__0\"],[12],[1,\"\\n\"],[1,\"        \"],[8,[39,5],null,[[\"@qaClass\",\"@invalidText\",\"@placeHolder\",\"@field\",\"@showErrors\",\"@value\",\"@setSuggestion\",\"@isDisabled\",\"@isRequired\"],[\"qa--address_zip\",[28,[37,0],[\"errors.address.invalid_postal_code\"],null],[28,[37,0],[\"account.subscription.billing.address.zip_code\"],null],[30,0,[\"addressFieldKeys\",\"POSTAL_CODE\"]],[30,2],[30,11],[30,7],[30,5],[28,[37,6],[[30,0,[\"addressFieldKeys\",\"POSTAL_CODE\"]],[30,0,[\"requiredFields\"]]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasSameLineEmptyErrors\"]],[[[1,\"      \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"o--form__helpText is--error u--m__tb__xs\"],[12],[1,[30,0,[\"sameLineErrorText\"]]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"&attrs\",\"@showErrors\",\"@country\",\"@setSelectedCountry\",\"@isDisabled\",\"@line1\",\"@setSuggestion\",\"@line2\",\"@city\",\"@state\",\"@postalCode\"],false,[\"t\",\"if\",\"and\",\"svg-jar\",\"shared/address-fields/country\",\"shared/address-fields/item\",\"includes\"]]",
    "moduleName": "shared/components/shared/address-fields.hbs",
    "isStrictMode": false
  });

  /**
   * @class Shared::AddressFields
   * @extends Component
   *
   * This component is collection of an address inputs for a user to enter their street address
   * On usage of this component, it needs to be wrapped in a form to handle saving or submission of the form
   *
   *  Required Arguments:
   * - [country] (String) string text of two letter country code.
   * - [line1] (String) string text of address line 1.
   * - [line2] (String) string text of address line 2 (unit number). Can be empty string.
   * - [city] (String) string text of city.
   * - [showErrors] (Boolean) used to determine if errors should be shown. Can be used so that errors are not visible on page load
   * - [state] (String) string text of state.
   * - [postalCode] (String) string text of zip or postal code.
   * - [setSelectedCountry] (Action) handler that sets country when power select dropdown is changed
   *
   *
   * Inline Usage with all options:
   * ```
   *<Shared::AddressFields
   *  @country={{"CA"}}
   *  @line1={{"204 address street"}}
   *  @line2={{"Unit 1"}}
   *  @city={{"City"}}
   *  @showErrors={{true}}
   *  @state={{"Kansas"}}
   *  @postalCode={{"11111"}}
   *  @setSelectedCountry={{this.setSelectedCountry}}
   * />
   * ```
   */
  let SharedAddressFields = (_class = class SharedAddressFields extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "address", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _defineProperty(this, "addressFieldKeys", _constants.ADDRESS_FIELD_KEYS);
    }

    get sameLineErrorText() {
      const allLinesEmpty = 3;
      return this.sameLineEmptyErrorsAmount === allLinesEmpty ? this.intl.t('errors.address.empty.city_postal_state') : this.generateEmptyErrorCopy(this.emptyStatesSameLine);
    }

    get emptyStatesSameLine() {
      return {
        [this.addressFieldKeys.CITY]: this.isFieldRequiredAndEmpty(this.addressFieldKeys.CITY),
        [this.addressFieldKeys.STATE]: this.isFieldRequiredAndEmpty(this.addressFieldKeys.STATE),
        [this.addressFieldKeys.POSTAL_CODE]: this.isFieldRequiredAndEmpty(this.addressFieldKeys.POSTAL_CODE)
      };
    }

    get hasSameLineEmptyErrors() {
      return this.sameLineEmptyErrorsAmount > 0 && this.args.showErrors;
    }

    get sameLineEmptyErrorsAmount() {
      return Object.values(this.emptyStatesSameLine).filter(value => value).length;
    }

    get unsavedAddressNotFound() {
      return this.address.isUnsavedAddressNotFound;
    }

    get suggestedChanges() {
      return this.address.suggestedChanges;
    }

    get requiredFields() {
      return this.address.getRequiredFields(this.args.country);
    }
    /**
     *
     * @param {string} field key of ADDRESS_FIELD_KEYS. Example: postalCode
     * @returns {boolean}
     */


    isFieldRequiredAndEmpty(field) {
      return this.requiredFields.includes(field) && !(0, _utils.isPresent)(this.args[field]);
    }

    generateEmptyErrorCopy(lineStates) {
      const copyDictionary = {
        [this.addressFieldKeys.POSTAL_CODE]: this.intl.t('errors.address.empty.postal_code'),
        [this.addressFieldKeys.CITY]: this.intl.t('errors.address.empty.city'),
        [this.addressFieldKeys.STATE]: this.intl.t('errors.address.empty.state')
      };
      return Object.entries(lineStates) // eslint-disable-next-line no-unused-vars
      .filter(_ref2 => {
        let [_, value] = _ref2;
        return value;
      }).reduce((errorMessage, _ref3, index) => {
        let [key] = _ref3;
        let partialErrorMessage = '';

        if (index > 0) {
          partialErrorMessage += this.intl.t('errors.address.empty.conjunction');
        }

        partialErrorMessage += copyDictionary[key];
        return errorMessage + partialErrorMessage;
      }, "".concat(this.intl.t('errors.address.empty.prefix'))).concat('.');
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = SharedAddressFields;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SharedAddressFields);
});